module.exports = __webpack_public_path__ + "06957abe3920ff88fd449ea9f32024b2.pdf";